export default {
  // General metadata translations
  loadingDefinitions: 'Loading metadata definitions...',
  noDefinitionsAvailable: 'No metadata definitions available for this resource type.',
  enterValue: 'Enter value',
  removeField: 'Remove field',

  // Metadata field definitions
  fields: {
    ideal_stock: {
      label: 'Ideal Stock',
      description: 'Ideal quantity in stock'
    },
    critical_stock: {
      label: 'Critical Stock',
      description: 'Alert threshold for stock'
    },
    renewal_date: {
      label: 'Renewal Date',
      description: 'Expected renewal date'
    },
    unit: {
      label: 'Unit of Measure',
      description: 'Unit of measure for consumables (e.g.: kg, liters, pieces)'
    },
    owned_by: {
      label: 'Owner',
      description: 'User who owns the resource'
    },
    allows_participation: {
      label: 'Allow Participation',
      description: 'Allow other users to indicate their participation in borrowings of this resource'
    },
    reservation_managers: {
      label: 'Require Reservation Validation',
      description: 'Reservations must be validated by designated managers before borrowing',
      managersLabel: 'Reservation Managers',
      addPlaceholder: 'Add a manager...',
      searchPlaceholder: 'Search users...',
      noUsersFound: 'No users found',
      noManagers: 'No managers assigned. Add at least one manager for validation to work.'
    }
  }
};
